import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useLocation } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { CommonConfig } from '../../config/common-config';
import LoaderPopUp from '../../components/loaderpopup/loader';


const useStyles = makeStyles({
    parent: {
        textAlign: 'center',
        marginTop: '15px',
        marginBottom: '30px',
    },
    circle: {
        height: '40px',
        width: '40px',
        backgroundColor: '#4f4dad',
        borderRadius: '50%',
        display: 'inline-block',
        color: '#FFFFFF',
        paddingTop: '8px',
        fontWeight: 'bold',
        fontSize: '17px',
        cursor: 'pointer',
    },
    circleOutline: {
        height: '40px',
        width: '40px',
        color: '#4f4dad',
        borderRadius: '50%',
        display: 'inline-block',
        paddingTop: '5px',
        fontWeight: 'bold',
        fontSize: '17px',
        border: '0.1875em solid #4f4dad',
        cursor: 'pointer',
    },
    hrClass: {
        border: '2px solid #4f4dad',
        width: '8%',
        maxWidth: '100px',
        background: '#4f4dad',
        fontSize: '2px',
        display: 'inline-block',
    },
});

export default function ProgressNav(props) {
    const classes = useStyles();
    const [page, setPage] = useState(1);

    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;

    const [checklist, setChecklist] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const location = useLocation();
    // const serviceIdValue = location.state.id;

    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    //console.log('serviceIdValue', serviceIdValue);

    useEffect(() => {
        if (props.pageNo) {
            setPage(props.pageNo);
        }
    }, [props]);

    const handleClick = (val) => {
        setShowLoader(true);
        if (val === 8) {
            console.log("8 th TAB");
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
            props.handlePageChange(val);
        } else {
            console.log("others");
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
            props.handlePageChange(val);
        }
    };

    ////console.log('Page From Progress nav', props.pageNo);
    useEffect(() => {
        const bearerToken = `Bearer ${userToken}`;
        ////console.log('bearerToken.add', bearerToken);
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${(usertype === 'Ultimate Client' || usertype === 'EM') ? tennantnameValue : imcNameSelected}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log('response', response.data);
                setChecklist(response.data);
            })
            .catch((error) => { });
    }, [userToken]);

    const handleClose = () => {
        setShowLoader(false);
    };

    return (
        <>
            {showLoader ? (<LoaderPopUp showLoader={showLoader} handleClose={handleClose} />) : null}

            <div className={classes.parent}>
                <span className={page >= 1 ? classes.circle : classes.circleOutline} onClick={() => handleClick(1)}>
                    1
            </span>
                <hr className={classes.hrClass} />

                <span className={page >= 2 ? classes.circle : classes.circleOutline} onClick={() => handleClick(2)}>
                    2
            </span>
                <hr className={classes.hrClass} />

                <span className={page >= 3 ? classes.circle : classes.circleOutline} onClick={() => handleClick(3)}>
                    3
            </span>
                <hr className={classes.hrClass} />

                <span className={page >= 4 ? classes.circle : classes.circleOutline} onClick={() => handleClick(4)}>
                    4
            </span>
                <hr className={classes.hrClass} />

                <span className={page >= 5 ? classes.circle : classes.circleOutline} onClick={() => handleClick(5)}>
                    5
            </span>
                <hr className={classes.hrClass} />

                <span className={page >= 6 ? classes.circle : classes.circleOutline} onClick={() => handleClick(6)}>
                    6
            </span>
                <hr className={classes.hrClass} />

                <span className={page >= 7 ? classes.circle : classes.circleOutline} onClick={() => handleClick(7)}>
                    7
            </span>
                <hr className={classes.hrClass} />

                <span className={page >= 8 ? classes.circle : classes.circleOutline} onClick={() => handleClick(8)}>
                    8
            </span>
                {checklist && checklist.length >= 1 ? (
                    <span>
                        {/* <div> */}
                        {/* Uncomment div its necessary  */}
                        <hr className={classes.hrClass} />
                        <span className={page >= 9 ? classes.circle : classes.circleOutline} onClick={() => handleClick(9)}>
                            9
                    </span>
                        {/* </div> */}
                    </span>
                ) : (
                        ''
                    )}
            </div>
        </>
    );
}
